import { signal } from '@angular/core';

import { DealerConfig } from '../interfaces';

export const dealerConfig = signal<DealerConfig | null>(null);
